import React from 'react';
import HeroSlider from '../components/HeroSlider';
import About from '../components/About';
import AISection from '../components/AISection';
import Services from '../components/Services';
import QuoteBand from '../components/QuoteBand';
import ContactSection from '../components/ContactSection';

export default function HomePage() {
  return (
    <>
      <HeroSlider />
      <About />
      <AISection />
      <Services />
      <QuoteBand />
      <ContactSection />
    </>
  );
}
